<template>
    
    <div id="base" class="">

     

      <!-- Unnamed (Rectangle) -->
      <div id="u2726" class="ax_default box_1">
        <div id="u2726_div" class=""></div>
        <div id="u2726_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2727" class="ax_default box_1">
        <div id="u2727_div" class=""></div>
        <div id="u2727_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2728" class="ax_default box_1">
        <div id="u2728_div" class=""></div>
        <div id="u2728_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2729" class="ax_default button"  @click="setFlag1(1)">
        <div id="u2729_div" class=""></div>
        <div id="u2729_text" class="text ">
          <p><span>月</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2730" class="ax_default button"  @click="setFlag1(2)">
        <div id="u2730_div" class=""></div>
        <div id="u2730_text" class="text ">
          <p><span>季</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u2731" class="ax_default line">
        <img id="u2731_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u2731_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2732" class="ax_default button"  @click="setFlag1(3)">
        <div id="u2732_div" class=""></div>
        <div id="u2732_text" class="text ">
          <p><span>年</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u2733" class="ax_default line">
        <img id="u2733_img" class="img " src="../../../../../../assets/common/carbon/icon/month/u2733.svg"/>
        <div id="u2733_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2734" class="ax_default label">
        <div id="u2734_div" class=""></div>
        <div id="u2734_text" class="text ">
          <p><span>月度碳排放量&amp;同比变化量&amp;同比变化率</span></p>
        </div>
      </div>



      <!-- Unnamed (Image) -->
  

      <!-- Unnamed (Rectangle) -->
      <div id="u2737" class="ax_default box_1">
        <div id="u2737_div" class=""></div>
        <div id="u2737_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2738" class="ax_default heading_3">
        <div id="u2738_div" class=""></div>
        <div id="u2738_text" class="text ">
          <p><span>LOGO</span></p>
        </div>
      </div>

<div id="u28581" class="ax_default" >
 
            <el-radio-group v-model="radio" @change="getChange">
    <el-radio :label="1">总排放量</el-radio>
    <el-radio :label="2">直接排放量</el-radio>
    <el-radio :label="3">间接排放量</el-radio>
    
  </el-radio-group>
  </div>
    
    

      <!-- Unnamed (Rectangle) -->
      <div id="u2861" class="ax_default box_1">
        <div id="u2861_div" class=""></div>
        <div id="u2861_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u2862" class="ax_default line">
        <img id="u2862_img" class="img " src="../../../../../../assets/common/carbon/icon/month/u2862.svg"/>
        <div id="u2862_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2863" class="ax_default label">
        <div id="u2863_div" class=""></div>
        <div id="u2863_text" class="text ">
          <p><span>排放量预测</span></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u2864" class="ax_default image">
        <v-chart
          ref="barChart"
          style="width: 100%;height:330px"
          :options="monthlyProportionOptionsForecast"
          theme="macarons"
          :auto-resize="true"
        ></v-chart>
        <div id="u2864_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u2865" class="ax_default" data-left="259" data-top="695" data-width="1149" data-height="203">

        <!-- Unnamed (Rectangle) -->
        <div id="u2866" class="ax_default label">
          <div id="u2866_div" class=""></div>
          <div id="u2866_text" class="text ">
            <p><span>排放量详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2867" class="ax_default box_1">
          <div id="u2867_div" class=""></div>
          <div id="u2867_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2868" class="ax_default label">
          <div id="u2868_div" class=""></div>
          <div id="u2868_text" class="text ">
            <p><span>排放类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u2869" class="ax_default droplist">
          <div id="u2869_div" class=""></div>
          <select id="u2869_input" class="u2869_input" v-model="queryParams.carbonType">
            <option class="u2869_input_option" selected value="">请选择</option>
            <option class="u2869_input_option" value="1">直接排放</option>
            <option class="u2869_input_option" value="2">间接排放</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2870" class="ax_default label">
          <div id="u2870_div" class=""></div>
          <div id="u2870_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u2871" class="ax_default image">
           <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
                v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                     @change="setDateRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
          <div id="u2871_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2872" class="ax_default primary_button"  @click="handleQuery">
          <div id="u2872_div" class=""></div>
          <div id="u2872_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2873" class="ax_default box_1">
          <div id="u2873_div" class=""></div>
          <div id="u2873_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2874" class="ax_default heading_1">
          <div id="u2874_div" class=""></div>
          <div id="u2874_text" class="text ">
            <p><span>排放量</span></p>
          </div>
        </div>

        <!-- Unnamed (Line) -->
        <div id="u2875" class="ax_default _水平线">
          <img id="u2875_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u396.svg"/>
          <div id="u2875_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2876" class="ax_default heading_1">
          <div id="u2876_div" class=""></div>
          <div id="u2876_text" class="text ">
            <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">时间</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2877" class="ax_default primary_button">
          <div id="u2877_div" class=""></div>
          <div id="u2877_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2878" class="ax_default label">
          <div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">

         <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="carbonMonth" />
                <el-table-column label="能耗类型" align="center" prop="carbonType" />
                <el-table-column label="排放量" align="center" prop="useusage" />
             
               
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

        <!-- Unnamed (Rectangle) -->
  

        <!-- Unnamed (Rectangle) -->
        <div id="u2880" class="ax_default heading_1">
          <div id="u2880_div" class=""></div>
          <div id="u2880_text" class="text ">
            <p><span></span></p>
          </div>
        </div>
      </div>

 
    

      <div id="u2906" class="ax_default" data-left="290" data-top="283" data-width="456" data-height="318">
       <div id="u2908" class="ax_default image">
         <v-chart
            ref="lineChart"
            style="width: 100%;height:330px"
            :options="monthlyProportionOptionsRate"
            theme="macarons"
            :auto-resize="true"
          ></v-chart>
       </div>

      </div>

 

    </div>
  
    
 

</template>
<script>
import "echarts/theme/macarons";
import {
  getCarbonLevel1,
  listCarbon,
} from "@/api/business/energy/carbon";
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
    components: {Pagination},
  data() {
    return {
        flag:1,
          radio: 1,
         // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      carbonList: [],
      consumptionList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
          queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   carbonType: '',
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      feeTypeList: [
        { itemCode: 1, itemName: "直接排放" },
        { itemCode: 2, itemName: "间接排放" },
      ],

      //-----总碳排放
      monthlyProportionOptions: null,
      seasonProportionOptions: null,
      yearlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsForecast: null,
      seasonProportionOptionsRate: null,
      yearlyProportionOptionsRate: null,
          //----直接碳排放
      powermonthlyProportionOptions: null,
      powerseasonProportionOptions: null,
      poweryearlyProportionOptions: null,
      powermonthlyProportionOptionsRate: null,
      powerseasonProportionOptionsRate: null,
      poweryearlyProportionOptionsRate: null,
      //----间接碳排放
      gasmonthlyProportionOptions: null,
      gasseasonProportionOptions: null,
      gasyearlyProportionOptions: null,
      gasmonthlyProportionOptionsRate: null,
      gasseasonProportionOptionsRate: null,
      gasyearlyProportionOptionsRate: null,
  
     //接收统计数据的对象
       carbonLevel1VO: {
         //----------汇总数据-------------
            //今年总量

            totalYear: "",
            directYear: "",
            indirectYear: "",



            //---今年用量变化
            directChangeYear: "",
            totalChangeYear: "",
            indirectChangeYear: "",


            //---今年用量变化率
            directChangeRateYear: "",
            totalChangeRateYear: "",
            indirectChangeRateYear: "",


            //--下一周期预测
            directForecastYear: "",
            totalForecastYear: "",
            indirectForecastYear: "",


            //----------------直接-----------------------------
            //季总量
            directSeason1: "",
            directSeason2: "",
            directSeason3: "",
            directSeason4: "",

            //---季度用量变化
            directChangeSeason1: "",
            directChangeSeason2: "",
            directChangeSeason3: "",
            directChangeSeason4: "",

            //---季用量变化率
            directChangeRateSeason1: "",
            directChangeRateSeason2: "",
            directChangeRateSeason3: "",
            directChangeRateSeason4: "",

            //--季下一周期预测
            directForecastSeason1: "",
            directForecastSeason2: "",
            directForecastSeason3: "",
            directForecastSeason4: "",


            //---------------总----------------------------------------

            //总量
            totalSeason1: "",
            totalSeason2: "",
            totalSeason3: "",
            totalSeason4: "",
            //---季度用量变化
            totalChangeSeason1: "",
            totalChangeSeason2: "",
            totalChangeSeason3: "",
            totalChangeSeason4: "",

            //---季用量变化率
            totalChangeRateSeason1: "",
            totalChangeRateSeason2: "",
            totalChangeRateSeason3: "",
            totalChangeRateSeason4: "",

            //--季下一周期预测
            totalForecastSeason1: "",
            totalForecastSeason2: "",
            totalForecastSeason3: "",
            totalForecastSeason4: "",

            //--------------间接-------------------------------------
            //季总量
            indirectSeason1: "",
            indirectSeason2: "",
            indirectSeason3: "",
            indirectSeason4: "",
            //---季度用量变化
            indirectChangeSeason1: "",
            indirectChangeSeason2: "",
            indirectChangeSeason3: "",
            indirectChangeSeason4: "",
            //---季用量变化率
            indirectChangeRateSeason1: "",
            indirectChangeRateSeason2: "",
            indirectChangeRateSeason3: "",
            indirectChangeRateSeason4: "",

            //--季下一周期预测
            indirectForecastSeason1: "",
            indirectForecastSeason2: "",
            indirectForecastSeason3: "",
            indirectForecastSeason4: "",


            //-------------直接----------------------------
            //月总量
            directMonth1: "",
            directMonth2: "",
            directMonth3: "",
            directMonth4: "",
            directMonth5: "",
            directMonth6: "",
            directMonth7: "",
            directMonth8: "",
            directMonth9: "",
            directMonth10: "",
            directMonth11: "",
            directMonth12: "",

            //月变化
            directChangeMonth1: "",
            directChangeMonth2: "",
            directChangeMonth3: "",
            directChangeMonth4: "",
            directChangeMonth5: "",
            directChangeMonth6: "",
            directChangeMonth7: "",
            directChangeMonth8: "",
            directChangeMonth9: "",
            directChangeMonth10: "",
            directChangeMonth11: "",
            directChangeMonth12: "",
            //---月变化率
            directChangeRateMonth1: "",
            directChangeRateMonth2: "",
            directChangeRateMonth3: "",
            directChangeRateMonth4: "",
            directChangeRateMonth5: "",
            directChangeRateMonth6: "",
            directChangeRateMonth7: "",
            directChangeRateMonth8: "",
            directChangeRateMonth9: "",
            directChangeRateMonth10: "",
            directChangeRateMonth11: "",
            directChangeRateMonth12: "",


            //--月下一周期预测
            directForecastMonth1: "",
            directForecastMonth2: "",
            directForecastMonth3: "",
            directForecastMonth4: "",
            directForecastMonth5: "",
            directForecastMonth6: "",
            directForecastMonth7: "",
            directForecastMonth8: "",
            directForecastMonth9: "",
            directForecastMonth10: "",
            directForecastMonth11: "",
            directForecastMonth12: "",
            //--------------------
            //总量
            totalMonth1: "",
            totalMonth2: "",
            totalMonth3: "",
            totalMonth4: "",
            totalMonth5: "",
            totalMonth6: "",
            totalMonth7: "",
            totalMonth8: "",
            totalMonth9: "",
            totalMonth10: "",
            totalMonth11: "",
            totalMonth12: "",
            //月变化
            totalChangeMonth1: "",
            totalChangeMonth2: "",
            totalChangeMonth3: "",
            totalChangeMonth4: "",
            totalChangeMonth5: "",
            totalChangeMonth6: "",
            totalChangeMonth7: "",
            totalChangeMonth8: "",
            totalChangeMonth9: "",
            totalChangeMonth10: "",
            totalChangeMonth11: "",
            totalChangeMonth12: "",
            //---月变化率
            totalChangeRateMonth1: "",
            totalChangeRateMonth2: "",
            totalChangeRateMonth3: "",
            totalChangeRateMonth4: "",
            totalChangeRateMonth5: "",
            totalChangeRateMonth6: "",
            totalChangeRateMonth7: "",
            totalChangeRateMonth8: "",
            totalChangeRateMonth9: "",
            totalChangeRateMonth10: "",
            totalChangeRateMonth11: "",
            totalChangeRateMonth12: "",


            //--月下一周期预测
            totalForecastMonth1: "",
            totalForecastMonth2: "",
            totalForecastMonth3: "",
            totalForecastMonth4: "",
            totalForecastMonth5: "",
            totalForecastMonth6: "",
            totalForecastMonth7: "",
            totalForecastMonth8: "",
            totalForecastMonth9: "",
            totalForecastMonth10: "",
            totalForecastMonth11: "",
            totalForecastMonth12: "",
            //间接
            indirectMonth1: "",
            indirectMonth2: "",
            indirectMonth3: "",
            indirectMonth4: "",
            indirectMonth5: "",
            indirectMonth6: "",
            indirectMonth7: "",
            indirectMonth8: "",
            indirectMonth9: "",
            indirectMonth10: "",
            indirectMonth11: "",
            indirectMonth12: "",
            //月变化
            indirectChangeMonth1: "",
            indirectChangeMonth2: "",
            indirectChangeMonth3: "",
            indirectChangeMonth4: "",
            indirectChangeMonth5: "",
            indirectChangeMonth6: "",
            indirectChangeMonth7: "",
            indirectChangeMonth8: "",
            indirectChangeMonth9: "",
            indirectChangeMonth10: "",
            indirectChangeMonth11: "",
            indirectChangeMonth12: "",
            //---变化率
            indirectChangeRateMonth1: "",
            indirectChangeRateMonth2: "",
            indirectChangeRateMonth3: "",
            indirectChangeRateMonth4: "",
            indirectChangeRateMonth5: "",
            indirectChangeRateMonth6: "",
            indirectChangeRateMonth7: "",
            indirectChangeRateMonth8: "",
            indirectChangeRateMonth9: "",
            indirectChangeRateMonth10: "",
            indirectChangeRateMonth11: "",
            indirectChangeRateMonth12: "",

            //--下一周期预测
            indirectForecastMonth1: "",
            indirectForecastMonth2: "",
            indirectForecastMonth3: "",
            indirectForecastMonth4: "",
            indirectForecastMonth5: "",
            indirectForecastMonth6: "",
            indirectForecastMonth7: "",
            indirectForecastMonth8: "",
            indirectForecastMonth9: "",
            indirectForecastMonth10: "",
            indirectForecastMonth11: "",
            indirectForecastMonth12: "",
        },


    };
  },
  created() {
  getCarbonLevel1(this.queryParams).then((response) => {
    // alert("11111");
        this.carbonLevel1VO = response.data;
       // alert("22222");
        //alert("totalYear=="+this.carbonLevel1VO.totalYear);
       // alert("change=="+this.carbonLevel1VO.totalChangeYear);
        //alert("changerate=="+this.carbonLevel1VO.totalChangeRateYear);
       // alert("forecast=="+this.carbonLevel1VO.totalForecastYear);
        //--------变化量
         // this.monthlyProportionOptions = this.monthlyProportion();
         this.monthlyProportionOptionsRate=this.monthlyProportionRate(1);
         this.monthlyProportionOptionsForecast = this.monthlyProportionForecast(1);
                });
    
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
                 /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;

      listCarbon(this.queryParams).then((response) => {
     
        for(var i=0;i<response.rows.length;i++){
        
            if(response.rows[i].carbonType==1){
               response.rows[i].carbonMonth=response.rows[i].carbonYear+'-'+response.rows[i].carbonMonth;
               response.rows[i].carbonType='电';
            }
            if(response.rows[i].carbonType==2){
              response.rows[i].carbonMonth=response.rows[i].carbonYear+'-'+response.rows[i].carbonMonth;
              
               response.rows[i].carbonType='直接碳排放';}
              if(response.rows[i].carbonType==3){
               response.rows[i].carbonMonth=response.rows[i].carbonYear+'-'+response.rows[i].carbonMonth;
              
               response.rows[i].carbonType='间接碳排放';}
            
            if(response.rows[i].carbonType==4){
              response.rows[i].carbonMonth=response.rows[i].carbonYear+'-'+response.rows[i].carbonMonth;
              
               response.rows[i].carbonType='热';
            }
              if(response.rows[i].carbonType==5){
                response.rows[i].carbonMonth=response.rows[i].carbonYear+'-'+response.rows[i].carbonMonth;
              
               response.rows[i].carbonType='其他能源'; 
              }
        }
      
        this.consumptionList = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
        getChange(typeid){
        if(typeid==1){
        
          //电月度数据 
  
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(1);
          this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(1);
          
        }else if(typeid==2){
          //水月度数据 
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(2);
           this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(2);
        }else if(typeid==3){
         //气月度数据 
         this.monthlyProportionOptionsRate = this.monthlyProportionRate(3);
          this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(3);
        }
      },
       monthlyProportionRate(flag){
          if(flag==null || flag=="undefined")
             flag=1;
            //change=this.consumptionLevel1VO.powerChangeMonth1;
           // changerate=this.consumptionLevel1VO.powerChangeRateMonth1;
           var value="";
           var change="";
           var changerate="";
           var dataarr=[];
           var date = new Date();
           var curmonth=date .getMonth(); 
             var montharr=[];
          //alert(curmonth+"--"+flag);
        
       switch(curmonth){
            case 11:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];
             break;
            case 10:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月'];
             break;
            case 9:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月'];
              break;
             case 8:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月'];
              break;
             case 7:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月'];
              break;
             case 6:
             montharr=['1月','2月','3月','4月','5月','6月','7月'];
              break;
             case 5:
             montharr=['1月','2月','3月','4月','5月','6月'];
              break;
             case 4:
             montharr=['1月','2月','3月','4月','5月'];
              break;
             case 3:
             montharr=['1月','2月','3月','4月'];  
              break; 
             case 2:
             montharr=['1月','2月','3月'];
              break;
             case 1:
             montharr=['1月','2月'];
              break;
             case 0:
             montharr=['1月'];
       }
          if(flag==1){
             switch(curmonth){
                case 0:
                  dataarr=[
                           { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 }
                          ];break;
                case 1: 
                  dataarr=[
                         { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                         { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                        ];break;
                case 2:
                  dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                          ];    break;              
                case 3:
                    dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                         
                         ];  break;
                case 4:
                    dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                         
                         ];  break;
                case 5:
                   dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                           { value: this.carbonLevel1VO.totalMonth6,month:6, change: this.carbonLevel1VO.totalChangeMonth6,changerate:this.carbonLevel1VO.totalChangeRateMonth6 },
                        
                         ];  break;
                case 6:
                    dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                           { value: this.carbonLevel1VO.totalMonth6,month:6, change: this.carbonLevel1VO.totalChangeMonth6,changerate:this.carbonLevel1VO.totalChangeRateMonth6 },
                         { value: this.carbonLevel1VO.totalMonth7,month:7, change: this.carbonLevel1VO.totalChangeMonth7,changerate:this.carbonLevel1VO.totalChangeRateMonth7 },
                        
                         ];  break;
                case 7: 
                  dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                           { value: this.carbonLevel1VO.totalMonth6,month:6, change: this.carbonLevel1VO.totalChangeMonth6,changerate:this.carbonLevel1VO.totalChangeRateMonth6 },
                         { value: this.carbonLevel1VO.totalMonth7,month:7, change: this.carbonLevel1VO.totalChangeMonth7,changerate:this.carbonLevel1VO.totalChangeRateMonth7 },
                         { value: this.carbonLevel1VO.totalMonth8,month:8, change: this.carbonLevel1VO.totalChangeMonth8,changerate:this.carbonLevel1VO.totalChangeRateMonth8 },
                        
                         ];  break;
                case 8:
                  dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                           { value: this.carbonLevel1VO.totalMonth6,month:6, change: this.carbonLevel1VO.totalChangeMonth6,changerate:this.carbonLevel1VO.totalChangeRateMonth6 },
                         { value: this.carbonLevel1VO.totalMonth7,month:7, change: this.carbonLevel1VO.totalChangeMonth7,changerate:this.carbonLevel1VO.totalChangeRateMonth7 },
                         { value: this.carbonLevel1VO.totalMonth8,month:8, change: this.carbonLevel1VO.totalChangeMonth8,changerate:this.carbonLevel1VO.totalChangeRateMonth8 },
                        { value: this.carbonLevel1VO.totalMonth9,month:9, change: this.carbonLevel1VO.totalChangeMonth9,changerate:this.carbonLevel1VO.totalChangeRateMonth9 },
                        
                         ];  break;
                case 9:
                  dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                           { value: this.carbonLevel1VO.totalMonth6,month:6, change: this.carbonLevel1VO.totalChangeMonth6,changerate:this.carbonLevel1VO.totalChangeRateMonth6 },
                         { value: this.carbonLevel1VO.totalMonth7,month:7, change: this.carbonLevel1VO.totalChangeMonth7,changerate:this.carbonLevel1VO.totalChangeRateMonth7 },
                         { value: this.carbonLevel1VO.totalMonth8,month:8, change: this.carbonLevel1VO.totalChangeMonth8,changerate:this.carbonLevel1VO.totalChangeRateMonth8 },
                        { value: this.carbonLevel1VO.totalMonth9,month:9, change: this.carbonLevel1VO.totalChangeMonth9,changerate:this.carbonLevel1VO.totalChangeRateMonth9 },
                        { value: this.carbonLevel1VO.totalMonth10,month:10, change: this.carbonLevel1VO.totalChangeMonth10,changerate:this.carbonLevel1VO.totalChangeRateMonth10 },
                        
                         ];  break;
                case 10:
                    dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                           { value: this.carbonLevel1VO.totalMonth6,month:6, change: this.carbonLevel1VO.totalChangeMonth6,changerate:this.carbonLevel1VO.totalChangeRateMonth6 },
                         { value: this.carbonLevel1VO.totalMonth7,month:7, change: this.carbonLevel1VO.totalChangeMonth7,changerate:this.carbonLevel1VO.totalChangeRateMonth7 },
                         { value: this.carbonLevel1VO.totalMonth8,month:8, change: this.carbonLevel1VO.totalChangeMonth8,changerate:this.carbonLevel1VO.totalChangeRateMonth8 },
                        { value: this.carbonLevel1VO.totalMonth9,month:9, change: this.carbonLevel1VO.totalChangeMonth9,changerate:this.carbonLevel1VO.totalChangeRateMonth9 },
                        { value: this.carbonLevel1VO.totalMonth10,month:10, change: this.carbonLevel1VO.totalChangeMonth10,changerate:this.carbonLevel1VO.totalChangeRateMonth10 },
                         { value: this.carbonLevel1VO.totalMonth11,month:11, change: this.carbonLevel1VO.totalChangeMonth11,changerate:this.carbonLevel1VO.totalChangeRateMonth11 },
                       
                         ];  break;
                case 11:
dataarr=[
                            { value: this.carbonLevel1VO.totalMonth1,month:1, change: this.carbonLevel1VO.totalChangeMonth1,changerate:this.carbonLevel1VO.totalChangeRateMonth1 },
                            { value: this.carbonLevel1VO.totalMonth2,month:2, change: this.carbonLevel1VO.totalChangeMonth2,changerate:this.carbonLevel1VO.totalChangeRateMonth2 },
                            { value: this.carbonLevel1VO.totalMonth3,month:3, change: this.carbonLevel1VO.totalChangeMonth3,changerate:this.carbonLevel1VO.totalChangeRateMonth3 },
                            { value: this.carbonLevel1VO.totalMonth4,month:4, change: this.carbonLevel1VO.totalChangeMonth4,changerate:this.carbonLevel1VO.totalChangeRateMonth4 },
                          { value: this.carbonLevel1VO.totalMonth5,month:5, change: this.carbonLevel1VO.totalChangeMonth5,changerate:this.carbonLevel1VO.totalChangeRateMonth5 },
                           { value: this.carbonLevel1VO.totalMonth6,month:6, change: this.carbonLevel1VO.totalChangeMonth6,changerate:this.carbonLevel1VO.totalChangeRateMonth6 },
                         { value: this.carbonLevel1VO.totalMonth7,month:7, change: this.carbonLevel1VO.totalChangeMonth7,changerate:this.carbonLevel1VO.totalChangeRateMonth7 },
                         { value: this.carbonLevel1VO.totalMonth8,month:8, change: this.carbonLevel1VO.totalChangeMonth8,changerate:this.carbonLevel1VO.totalChangeRateMonth8 },
                        { value: this.carbonLevel1VO.totalMonth9,month:9, change: this.carbonLevel1VO.totalChangeMonth9,changerate:this.carbonLevel1VO.totalChangeRateMonth9 },
                        { value: this.carbonLevel1VO.totalMonth10,month:10, change: this.carbonLevel1VO.totalChangeMonth10,changerate:this.carbonLevel1VO.totalChangeRateMonth10 },
                         { value: this.carbonLevel1VO.totalMonth11,month:11, change: this.carbonLevel1VO.totalChangeMonth11,changerate:this.carbonLevel1VO.totalChangeRateMonth11 },
                         { value: this.carbonLevel1VO.totalMonth12,month:12, change: this.carbonLevel1VO.totalChangeMonth12,changerate:this.carbonLevel1VO.totalChangeRateMonth12 },
                       
                         ];  break;
             }
            // dataarr=
          }
          if(flag==2){
           
             switch(curmonth){
               case 0:
                  dataarr=[
                           { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 }
                          ];break;
                case 1: 
                  dataarr=[
                         { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                         { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                        ];break;
                case 2:
                  dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                          ];    break;              
                case 3:
                    dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                         
                         ];  break;
                case 4:
                    dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                         
                         ];  break;
                case 5:
                   dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                           { value: this.carbonLevel1VO.directMonth6,month:6, change: this.carbonLevel1VO.directChangeMonth6,changerate:this.carbonLevel1VO.directChangeRateMonth6 },
                        
                         ];  break;
                case 6:
                    dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                           { value: this.carbonLevel1VO.directMonth6,month:6, change: this.carbonLevel1VO.directChangeMonth6,changerate:this.carbonLevel1VO.directChangeRateMonth6 },
                         { value: this.carbonLevel1VO.directMonth7,month:7, change: this.carbonLevel1VO.directChangeMonth7,changerate:this.carbonLevel1VO.directChangeRateMonth7 },
                        
                         ];  break;
                case 7: 
                  dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                           { value: this.carbonLevel1VO.directMonth6,month:6, change: this.carbonLevel1VO.directChangeMonth6,changerate:this.carbonLevel1VO.directChangeRateMonth6 },
                         { value: this.carbonLevel1VO.directMonth7,month:7, change: this.carbonLevel1VO.directChangeMonth7,changerate:this.carbonLevel1VO.directChangeRateMonth7 },
                         { value: this.carbonLevel1VO.directMonth8,month:8, change: this.carbonLevel1VO.directChangeMonth8,changerate:this.carbonLevel1VO.directChangeRateMonth8 },
                        
                         ];  break;
                case 8:
                        
                  dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                           { value: this.carbonLevel1VO.directMonth6,month:6, change: this.carbonLevel1VO.directChangeMonth6,changerate:this.carbonLevel1VO.directChangeRateMonth6 },
                         { value: this.carbonLevel1VO.directMonth7,month:7, change: this.carbonLevel1VO.directChangeMonth7,changerate:this.carbonLevel1VO.directChangeRateMonth7 },
                         { value: this.carbonLevel1VO.directMonth8,month:8, change: this.carbonLevel1VO.directChangeMonth8,changerate:this.carbonLevel1VO.directChangeRateMonth8 },
                        { value: this.carbonLevel1VO.directMonth9,month:9, change: this.carbonLevel1VO.directChangeMonth9,changerate:this.carbonLevel1VO.directChangeRateMonth9 },
                        
                         ];  break;
                case 9:
                
                  dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                           { value: this.carbonLevel1VO.directMonth6,month:6, change: this.carbonLevel1VO.directChangeMonth6,changerate:this.carbonLevel1VO.directChangeRateMonth6 },
                         { value: this.carbonLevel1VO.directMonth7,month:7, change: this.carbonLevel1VO.directChangeMonth7,changerate:this.carbonLevel1VO.directChangeRateMonth7 },
                         { value: this.carbonLevel1VO.directMonth8,month:8, change: this.carbonLevel1VO.directChangeMonth8,changerate:this.carbonLevel1VO.directChangeRateMonth8 },
                        { value: this.carbonLevel1VO.directMonth9,month:9, change: this.carbonLevel1VO.directChangeMonth9,changerate:this.carbonLevel1VO.directChangeRateMonth9 },
                        { value: this.carbonLevel1VO.directMonth10,month:10, change: this.carbonLevel1VO.directChangeMonth10,changerate:this.carbonLevel1VO.directChangeRateMonth10 },
                        
                         ];  break;
                case 10:
                    dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                           { value: this.carbonLevel1VO.directMonth6,month:6, change: this.carbonLevel1VO.directChangeMonth6,changerate:this.carbonLevel1VO.directChangeRateMonth6 },
                         { value: this.carbonLevel1VO.directMonth7,month:7, change: this.carbonLevel1VO.directChangeMonth7,changerate:this.carbonLevel1VO.directChangeRateMonth7 },
                         { value: this.carbonLevel1VO.directMonth8,month:8, change: this.carbonLevel1VO.directChangeMonth8,changerate:this.carbonLevel1VO.directChangeRateMonth8 },
                        { value: this.carbonLevel1VO.directMonth9,month:9, change: this.carbonLevel1VO.directChangeMonth9,changerate:this.carbonLevel1VO.directChangeRateMonth9 },
                        { value: this.carbonLevel1VO.directMonth10,month:10, change: this.carbonLevel1VO.directChangeMonth10,changerate:this.carbonLevel1VO.directChangeRateMonth10 },
                         { value: this.carbonLevel1VO.directMonth11,month:11, change: this.carbonLevel1VO.directChangeMonth11,changerate:this.carbonLevel1VO.directChangeRateMonth11 },
                       
                         ];  break;
                case 11:
dataarr=[
                            { value: this.carbonLevel1VO.directMonth1,month:1, change: this.carbonLevel1VO.directChangeMonth1,changerate:this.carbonLevel1VO.directChangeRateMonth1 },
                            { value: this.carbonLevel1VO.directMonth2,month:2, change: this.carbonLevel1VO.directChangeMonth2,changerate:this.carbonLevel1VO.directChangeRateMonth2 },
                            { value: this.carbonLevel1VO.directMonth3,month:3, change: this.carbonLevel1VO.directChangeMonth3,changerate:this.carbonLevel1VO.directChangeRateMonth3 },
                            { value: this.carbonLevel1VO.directMonth4,month:4, change: this.carbonLevel1VO.directChangeMonth4,changerate:this.carbonLevel1VO.directChangeRateMonth4 },
                          { value: this.carbonLevel1VO.directMonth5,month:5, change: this.carbonLevel1VO.directChangeMonth5,changerate:this.carbonLevel1VO.directChangeRateMonth5 },
                           { value: this.carbonLevel1VO.directMonth6,month:6, change: this.carbonLevel1VO.directChangeMonth6,changerate:this.carbonLevel1VO.directChangeRateMonth6 },
                         { value: this.carbonLevel1VO.directMonth7,month:7, change: this.carbonLevel1VO.directChangeMonth7,changerate:this.carbonLevel1VO.directChangeRateMonth7 },
                         { value: this.carbonLevel1VO.directMonth8,month:8, change: this.carbonLevel1VO.directChangeMonth8,changerate:this.carbonLevel1VO.directChangeRateMonth8 },
                        { value: this.carbonLevel1VO.directMonth9,month:9, change: this.carbonLevel1VO.directChangeMonth9,changerate:this.carbonLevel1VO.directChangeRateMonth9 },
                        { value: this.carbonLevel1VO.directMonth10,month:10, change: this.carbonLevel1VO.directChangeMonth10,changerate:this.carbonLevel1VO.directChangeRateMonth10 },
                         { value: this.carbonLevel1VO.directMonth11,month:11, change: this.carbonLevel1VO.directChangeMonth11,changerate:this.carbonLevel1VO.directChangeRateMonth11 },
                         { value: this.carbonLevel1VO.directMonth12,month:12, change: this.carbonLevel1VO.directChangeMonth12,changerate:this.carbonLevel1VO.directChangeRateMonth12 },
                       
                         ];  break;

             }
            // dataarr=
          }
          if(flag==3){
             switch(curmonth){
                case 0:
                  dataarr=[
                           { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 }
                          ];break;
                case 1: 
                  dataarr=[
                         { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                         { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                        ];break;
                case 2:
                  dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                          ];       break;           
                case 3:
                   dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                         
                         ];  break;
               case 4:
                    dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                         
                         ];  break;
                case 5:
                   dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                           { value: this.carbonLevel1VO.indirectMonth6,month:6, change: this.carbonLevel1VO.indirectChangeMonth6,changerate:this.carbonLevel1VO.indirectChangeRateMonth6 },
                        
                         ];  break;
                case 6:
                    dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                           { value: this.carbonLevel1VO.indirectMonth6,month:6, change: this.carbonLevel1VO.indirectChangeMonth6,changerate:this.carbonLevel1VO.indirectChangeRateMonth6 },
                         { value: this.carbonLevel1VO.indirectMonth7,month:7, change: this.carbonLevel1VO.indirectChangeMonth7,changerate:this.carbonLevel1VO.indirectChangeRateMonth7 },
                        
                         ];  break;
                case 7: 
                  dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                           { value: this.carbonLevel1VO.indirectMonth6,month:6, change: this.carbonLevel1VO.indirectChangeMonth6,changerate:this.carbonLevel1VO.indirectChangeRateMonth6 },
                         { value: this.carbonLevel1VO.indirectMonth7,month:7, change: this.carbonLevel1VO.indirectChangeMonth7,changerate:this.carbonLevel1VO.indirectChangeRateMonth7 },
                         { value: this.carbonLevel1VO.indirectMonth8,month:8, change: this.carbonLevel1VO.indirectChangeMonth8,changerate:this.carbonLevel1VO.indirectChangeRateMonth8 },
                        
                         ];  break;
                case 8:
                  dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                           { value: this.carbonLevel1VO.indirectMonth6,month:6, change: this.carbonLevel1VO.indirectChangeMonth6,changerate:this.carbonLevel1VO.indirectChangeRateMonth6 },
                         { value: this.carbonLevel1VO.indirectMonth7,month:7, change: this.carbonLevel1VO.indirectChangeMonth7,changerate:this.carbonLevel1VO.indirectChangeRateMonth7 },
                         { value: this.carbonLevel1VO.indirectMonth8,month:8, change: this.carbonLevel1VO.indirectChangeMonth8,changerate:this.carbonLevel1VO.indirectChangeRateMonth8 },
                        { value: this.carbonLevel1VO.indirectMonth9,month:9, change: this.carbonLevel1VO.indirectChangeMonth9,changerate:this.carbonLevel1VO.indirectChangeRateMonth9 },
                        
                         ];  break;
                case 9:
                  dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                           { value: this.carbonLevel1VO.indirectMonth6,month:6, change: this.carbonLevel1VO.indirectChangeMonth6,changerate:this.carbonLevel1VO.indirectChangeRateMonth6 },
                         { value: this.carbonLevel1VO.indirectMonth7,month:7, change: this.carbonLevel1VO.indirectChangeMonth7,changerate:this.carbonLevel1VO.indirectChangeRateMonth7 },
                         { value: this.carbonLevel1VO.indirectMonth8,month:8, change: this.carbonLevel1VO.indirectChangeMonth8,changerate:this.carbonLevel1VO.indirectChangeRateMonth8 },
                        { value: this.carbonLevel1VO.indirectMonth9,month:9, change: this.carbonLevel1VO.indirectChangeMonth9,changerate:this.carbonLevel1VO.indirectChangeRateMonth9 },
                        { value: this.carbonLevel1VO.indirectMonth10,month:10, change: this.carbonLevel1VO.indirectChangeMonth10,changerate:this.carbonLevel1VO.indirectChangeRateMonth10 },
                        
                         ];  break;
                case 10:
                    dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                           { value: this.carbonLevel1VO.indirectMonth6,month:6, change: this.carbonLevel1VO.indirectChangeMonth6,changerate:this.carbonLevel1VO.indirectChangeRateMonth6 },
                         { value: this.carbonLevel1VO.indirectMonth7,month:7, change: this.carbonLevel1VO.indirectChangeMonth7,changerate:this.carbonLevel1VO.indirectChangeRateMonth7 },
                         { value: this.carbonLevel1VO.indirectMonth8,month:8, change: this.carbonLevel1VO.indirectChangeMonth8,changerate:this.carbonLevel1VO.indirectChangeRateMonth8 },
                        { value: this.carbonLevel1VO.indirectMonth9,month:9, change: this.carbonLevel1VO.indirectChangeMonth9,changerate:this.carbonLevel1VO.indirectChangeRateMonth9 },
                        { value: this.carbonLevel1VO.indirectMonth10,month:10, change: this.carbonLevel1VO.indirectChangeMonth10,changerate:this.carbonLevel1VO.indirectChangeRateMonth10 },
                         { value: this.carbonLevel1VO.indirectMonth11,month:11, change: this.carbonLevel1VO.indirectChangeMonth11,changerate:this.carbonLevel1VO.indirectChangeRateMonth11 },
                       
                         ];  break;
                case 11:
dataarr=[
                            { value: this.carbonLevel1VO.indirectMonth1,month:1, change: this.carbonLevel1VO.indirectChangeMonth1,changerate:this.carbonLevel1VO.indirectChangeRateMonth1 },
                            { value: this.carbonLevel1VO.indirectMonth2,month:2, change: this.carbonLevel1VO.indirectChangeMonth2,changerate:this.carbonLevel1VO.indirectChangeRateMonth2 },
                            { value: this.carbonLevel1VO.indirectMonth3,month:3, change: this.carbonLevel1VO.indirectChangeMonth3,changerate:this.carbonLevel1VO.indirectChangeRateMonth3 },
                            { value: this.carbonLevel1VO.indirectMonth4,month:4, change: this.carbonLevel1VO.indirectChangeMonth4,changerate:this.carbonLevel1VO.indirectChangeRateMonth4 },
                          { value: this.carbonLevel1VO.indirectMonth5,month:5, change: this.carbonLevel1VO.indirectChangeMonth5,changerate:this.carbonLevel1VO.indirectChangeRateMonth5 },
                           { value: this.carbonLevel1VO.indirectMonth6,month:6, change: this.carbonLevel1VO.indirectChangeMonth6,changerate:this.carbonLevel1VO.indirectChangeRateMonth6 },
                         { value: this.carbonLevel1VO.indirectMonth7,month:7, change: this.carbonLevel1VO.indirectChangeMonth7,changerate:this.carbonLevel1VO.indirectChangeRateMonth7 },
                         { value: this.carbonLevel1VO.indirectMonth8,month:8, change: this.carbonLevel1VO.indirectChangeMonth8,changerate:this.carbonLevel1VO.indirectChangeRateMonth8 },
                        { value: this.carbonLevel1VO.indirectMonth9,month:9, change: this.carbonLevel1VO.indirectChangeMonth9,changerate:this.carbonLevel1VO.indirectChangeRateMonth9 },
                        { value: this.carbonLevel1VO.indirectMonth10,month:10, change: this.carbonLevel1VO.indirectChangeMonth10,changerate:this.carbonLevel1VO.indirectChangeRateMonth10 },
                         { value: this.carbonLevel1VO.indirectMonth11,month:11, change: this.carbonLevel1VO.indirectChangeMonth11,changerate:this.carbonLevel1VO.indirectChangeRateMonth11 },
                         { value: this.carbonLevel1VO.indirectMonth12,month:12, change: this.carbonLevel1VO.indirectChangeMonth12,changerate:this.carbonLevel1VO.indirectChangeRateMonth12 },
                       
                         ];  break;

             }
            // dataarr=
          }
      
            return {
              title: {
                text: "",
                textStyle: {
                  fontSize: 16,
                  color: "#000",
                  fontWeight: "bolder",
                },
              },
              tooltip: {
                trigger: "axis",
               // axisPointer: { type: "cross" },
                //trigger: 'item',
            formatter: function (params) {
               //console.log(params);
                    const item = params[0];
                  var color = params.color;//图例颜色
                  //var value = item.value;//y轴值
                 
                  var month=item.data.month;
                  var value = item.data.value;
                  var change=item.data.change;
                  var changerate=item.data.changerate;
                  if (value==null)
                      value="";
                  if (change==null)
                      change="";
                  if (changerate==null)
                      changerate="";    
                  var htmlStr ='<div align="left">';
                 
                 htmlStr += month + '月<br/>';//x轴的名称
                  //为了保证和原来的效果一样，这里自己实现了一个点的效果
                  htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';
                  htmlStr +=  '碳排放(吨二氧化碳):'+value+'<br/>';
                  htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';

                  htmlStr +=  '同比变化量(吨二氧化碳):'+change+'<br/>';
                  htmlStr += '<span style="margin-right:5px;display:inline-block;width:8px;height:10px;border-radius:5px;background-color:'+color+';"></span>';

                  htmlStr +=  '同比变化率:'+changerate+'<br/>';
                  // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                  //htmlStr += '<span style="color:'+color+'">';
                  
                  //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
                  //htmlStr += params.seriesName + '：'+params.value + '笔';
      
                  // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
                  //htmlStr += '</span>';
                  
                  htmlStr += '</div>';
                  
                  return htmlStr; 
           }


              },
              legend: [
               
              {
                 top:'25%',//距上边距

                left:'25%',//距离左边距

                 right:'25%',//距离右边距

                  bottom:'25%',//距离下边距
                
                    // x: "right",
                    y: "top",
                    data: [
                      "用电量(Kws)"
                    ]
                }
              ],
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              xAxis: [
                {
                  type: "category",
                  data: montharr,
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "",
                  axisLine: {show:true},
                  axisTick: {show:true},
                  splitLine:{show:true},
                  axisLabel: {
                    formatter: "{value} ",
                  },
                },
              ],
              series: [
                {
                  name: "用电量",
                  type: "line",
                  symbolSize: 6,
                   smooth:false,
                  itemStyle : {
                     normal : {
                        color:'#F1C232',
                        label : {show: true},
                     lineStyle:{
                       color:'#F6B26B',
                       width:4
                    }
                   }
                  },
                 
                  data:dataarr,
                },
              ],
            };
         },
         monthlyProportionForecast(flag) {
            var dataarr=[];
           var date = new Date();
           var curmonth=date .getMonth(); 
           var montharr=[];
          //alert(curmonth+"--"+flag);
        
       switch(curmonth){
            case 11:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'];
             break;
            case 10:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月'];
              break;
             case 9:

             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月'];
              break;
             case 8:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月','9月'];
              break;
             case 7:
             montharr=['1月','2月','3月','4月','5月','6月','7月','8月'];
              break;
             case 6:
             montharr=['1月','2月','3月','4月','5月','6月','7月'];
              break;
             case 5:
             montharr=['1月','2月','3月','4月','5月','6月'];
              break;
             case 4:
             montharr=['1月','2月','3月','4月','5月'];
              break; 
             case 3:
             montharr=['1月','2月','3月','4月'];
              break;
             case 2:
             montharr=['1月','2月','3月'];
              break;
             case 1:
             montharr=['1月','2月'];
              break;
             case 0:
             montharr=['1月'];
       }


          if(flag==1){
             switch(curmonth){
                case 0:
                  dataarr=[
                             { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            // { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            // { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            // { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            // { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            // { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            // { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            // { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                          ];
                           break;

                case 1: 
                  dataarr=[                                              
				 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            // { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            // { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            // { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            // { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            // { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            // { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },                  
                  ];
                   break;
                case 2:
                 
                 dataarr=[ 
                   { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            // { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            // { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            // { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            // { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            // { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                 ];      
                  break;             
                case 3:
                    dataarr=[
                          
			 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            // { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            // { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            // { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            // { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 4:
			 dataarr=[
                          
			
			 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            // { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            // { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            // { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 5:
			dataarr=[
                          
	 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            // { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            // { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 6:
			dataarr=[
                          
			
		 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            // { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 7: 
			dataarr=[
                          
				
		 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            // { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 8:
			dataarr=[
                          
		
		 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            // { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         ];  
                          break;
                case 9:
			dataarr=[
                          
		
			 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            // { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            // { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 10:
			dataarr=[

				
				 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                          //  { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 11:
			dataarr=[
 { value: this.carbonLevel1VO. totalForecastMonth1,month:1 },
                            { value: this.carbonLevel1VO. totalForecastMonth2,month:2 },
                            { value: this.carbonLevel1VO. totalForecastMonth3,month:3 },
                            { value: this.carbonLevel1VO. totalForecastMonth4,month:4 },
                            { value: this.carbonLevel1VO. totalForecastMonth5,month:5 },
                            { value: this.carbonLevel1VO. totalForecastMonth6,month:6 },
                            { value: this.carbonLevel1VO. totalForecastMonth7,month:7 },
                            { value: this.carbonLevel1VO. totalForecastMonth8,month:8 },
                            { value: this.carbonLevel1VO. totalForecastMonth9,month:9 },
                            { value: this.carbonLevel1VO. totalForecastMonth10,month:10 },
                            { value: this.carbonLevel1VO. totalForecastMonth11,month:11 },
                            { value: this.carbonLevel1VO. totalForecastMonth12,month:12 },
                         
                         ];  
                          break;
             }
      
          }
          if(flag==2){
      switch(curmonth){
                case 0:
                  dataarr=[
                               { value: this.carbonLevel1VO.directForecastMonth1,month:1 },
        //                         { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				// { value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				// { value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                          ];
                           break;
                case 1: 
                  dataarr=[
                       
                                
		{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				// { value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				// { value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },                  
                  ];
                   break;
                case 2:
                  dataarr=[
                           
			{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				// { value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                          ]; 
                           break;                 
                case 3:
                    dataarr=[
                          
		{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 4:
			 dataarr=[
                          
			
		{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         
                         ]; 
                          break; 
                case 5:
			dataarr=[
                          
				
		{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 6:
			dataarr=[
                          
			
		{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 7: 
			dataarr=[
                          
				
	{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         ];  
                          break;
                case 8:
			dataarr=[
                          
		
		{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         ];  
                          break;
                case 9:
			dataarr=[
                          
		
				
		{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				{ value: this.carbonLevel1VO.directForecastMonth10,month:10 },
			//	{ value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				//{ value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 10:
			dataarr=[

				
			{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				{ value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				{ value: this.carbonLevel1VO.directForecastMonth11,month:11 },
			//	{ value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 11:
			dataarr=[
{ value: this.carbonLevel1VO.directForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.directForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.directForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.directForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.directForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.directForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.directForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.directForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.directForecastMonth9,month:9 },
				{ value: this.carbonLevel1VO.directForecastMonth10,month:10 },
				{ value: this.carbonLevel1VO.directForecastMonth11,month:11 },
				{ value: this.carbonLevel1VO.directForecastMonth12,month:12 },
                         
                         ];  
                          break;
             }
          }
          if(flag==3){
      switch(curmonth){
                case 0:
                  dataarr=[
                                 { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
        //                         { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				// { value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				// { value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                          ];
                           break;
                case 1: 
                  dataarr=[
                       
            { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				// { value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				// { value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                          ];
         break;
                case 2:
                  dataarr=[
                           
		     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				// { value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                          ];   
                           break;               
                case 3:
                    dataarr=[
                          
		     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				// { value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 4:
			 dataarr=[
                          
			
			     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				// { value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 5:
			dataarr=[
                          
		     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				// { value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 6:
			dataarr=[
                          
			     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				// { value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 7: 
			dataarr=[
                          
				
	     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				// { value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 8:
			dataarr=[
                          
		
		     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				// { value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 9:
			dataarr=[
                          
		     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				{ value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				// { value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				// { value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         ]; 
                          break; 
                case 10:
			dataarr=[

				
	     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				{ value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				{ value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
			//	{ value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         
                         ];  
                          break;
                case 11:
			dataarr=[
	     { value: this.carbonLevel1VO.indirectForecastMonth1,month:1 },
                                { value: this.carbonLevel1VO.indirectForecastMonth2,month:2 },
				{ value: this.carbonLevel1VO.indirectForecastMonth3,month:3 },
				{ value: this.carbonLevel1VO.indirectForecastMonth4,month:4 },
				{ value: this.carbonLevel1VO.indirectForecastMonth5,month:5 },
				{ value: this.carbonLevel1VO.indirectForecastMonth6,month:6 },
				{ value: this.carbonLevel1VO.indirectForecastMonth7,month:7 },
				{ value: this.carbonLevel1VO.indirectForecastMonth8,month:8 },
				{ value: this.carbonLevel1VO.indirectForecastMonth9,month:9 },
				{ value: this.carbonLevel1VO.indirectForecastMonth10,month:10 },
				{ value: this.carbonLevel1VO.indirectForecastMonth11,month:11 },
				{ value: this.carbonLevel1VO.indirectForecastMonth12,month:12 },
                         ]; 
                          break; 
             }
          }
     
        
        
         // dataarr=[1,2,3];
        // alert(dataarr.toString());
      return {
        title: {
          text: "",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: [
          {
              align: "right",
              right: 50,
              // x: "right",
               y: "3%",
              data: [
                ""

            
              ]
          },
         {
            align: "right",
              right: 50,
              // x: "right",
               y: "10%",
              data: [
                "",
     
            
              ]
          }
        ],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: montharr,
            //    data: [
            //   '3月',
            //   '4月',
            //   '5月',
            //    "6",
            //    "7",
            //    "8",
            //    "9",
            //    "10",
            //    "11",
            //    "12",
            // ],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLine: {show:true},
            axisTick: {show:true},
            splitLine:{show:true},
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barWidth : '60%',
            itemStyle : {
                     normal : {
                        color:'#F6B26B',
                        label : {show: true,
                                position: 'top',
                                textStyle: {
                                  color: '#F6B26B'},
                        }
                   
                   }
                  },
            data: dataarr,
     
            
          }
        ],
      };
    },
   }
}
</script>
<style scope src="../../../../../../assets/common/carbon/css/month/styles.css"></style>
<style scope src="../../../../../../assets/common/consumption/css/styles.css"></style>
<style scope src="../../../../../../assets/common/rp_page.css"></style>
<style scoped>
.pagination-container {
  background: rgba(255, 255, 255, 0.0235294117647059);
  padding: 18px 0px;
  float: left;
  z-index: 99;
position: absolute;
}
   .innerbox{
            overflow-x: hidden;
            overflow-y: auto;       
        }
        /*滚动条样式*/
   .innerbox::-webkit-scrollbar {
           	width: 8px;
            height: 8px;
            background-color: #F5F5F5;
    }
    .innerbox::-webkit-scrollbar-thumb {
            	border-radius:3px;
	box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
    }
    .innerbox::-webkit-scrollbar-track {
          	box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 3px;
            background-color: #F5F5F5;

    }
  .fontset{
      font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;
      font-weight:400;
      font-style:normal;
  }
</style>
